<template>
  <div v-html="$t('additional-info')"></div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({});
</script>
